import { Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { Role } from 'src/app/core/models/role';
import { AdminService } from 'src/app/core/services/admin-service/admin.service';
import { AdminSharedDataService } from 'src/app/core/common/adminSharedDataService';
import { Constants } from 'src/app/core/constants/constant';
import { TeacherService } from 'src/app/core/services/teacher-service/teacher.service';
import { ReportAllService } from '../../../core/services/report-all/report-all.service';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-report-corses-statistics',
  templateUrl: './report-corses-statistics.component.html',
  styleUrls: ['./report-corses-statistics.component.scss']
})
export class ReportCorsesStatisticsComponent implements OnInit {
  urlImage = Constants.REST_API_MAIN;
  baseURL = Constants.REST_API_MAIN;
  searchModel: string = '';
  searchModel1: string = '';
  searchModel2: string = '';
  reportSubjectAll: any;
  dataLocal: any;
  localRole: any;
  id: any;
  dataTeacherAll: Array<any> = [];
  dataSubjectAll: Array<any> = [];
  dataLessonAll: Array<any> = [];
  selectedSubject: any = '';
  dataLoading1: boolean = true;
  dataLanguage: any;
  dataFindLesson: any = [];
  selectedLesson: any = '';
  studentLearnLesson: any = {
    countListAll: 0,
    countListSudentLearnToDay: 0
  };
  studyingCount: any;
  exam: any;
  dataLearnStudent: any;
  studyingList: any;
  dataStudyingOrigin: any = [];
  dataStudyingFilterOrigin: any = [];
  studyingToDayList: any;
  dataStudyingToDayOrigin: any = [];
  dataStudyingFilterToDayOrigin: any = [];
  studySuccesList: any;
  dataStudySuccesOrigin: any = [];
  dataStudySuccesFilterOrigin: any = [];
  dataStudyToDayOrigin: any = [];
  dataStudyToDayFilterOrigin: any = [];
  pageTotal: number = 10;
  pageTotal1: number = 5;
  pageTotal2: number = 5;
  page: number = 1;
  page1: number = 1;
  page2: number = 1;
  pageCount: number = 0;
  pageCount1: number = 0;
  pageCount2: number = 0;
  reportstudyList: any;
  @ViewChild('myCountStudentStudying') myCountStudentStudying;
  @ViewChild('myStudentStudyingList') myStudentStudyingList;
  @ViewChild('myStudentStudyingList2') myStudentStudyingList2;
  constructor(
    private adminService: AdminService,
    private adminSharedDataService: AdminSharedDataService,
    private teacherService: TeacherService,
    private reportLearnlesson: ReportAllService,
    @Inject(LOCALE_ID) private locale: string,
  ) { }

  ngOnInit() {
    var local = localStorage.getItem('currentUserLogin');
    if (local != null) {
      this.dataLocal = JSON.parse(local);
      this.localRole = this.dataLocal.role;
      if (this.dataLocal.role == Role.SuperAdmin || this.dataLocal.role == Role.Admin) {
        this.getTeacher();
      } else if (this.dataLocal.role == Role.Teacher) {
        this.id = this.dataLocal.id;
        this.reportSubjectAllTeacher(this.id);
      } else if (this.dataLocal.role == Role.Executive) {
        this.getTeacher();
      } else {
      }
    }
    this.onChangSelectPortal();
    this.getLanguage();
  }

  getTeacher() {
    var getSuccess: any;
    var data: any = [];
    this.adminService.fetchDataAllMemmerUser().then((response) => {
      getSuccess = response;

      for (let i = 0; i < getSuccess.dataTeachers.length; i++) {
        data.push({
          value: getSuccess.dataTeachers[i].por.tchId,
          label: getSuccess.dataTeachers[i].por.fullNameTh,
        });
      }
      this.dataTeacherAll = data;
    });
  }

  reportSubjectAllTeacher(id: any) {
    this.dataSubjectAll = [];

    this.adminService.ReportSubjectAllTeacher(id).then((res) => {
      var success = res;
      if (success.status == true && success.data.length > 0) {
        if (
          success.data != null &&
          success.data != undefined &&
          success.data != '' &&
          success.data.length != 0
        ) {
          var data: any = [];
          this.reportSubjectAll = success.data;
          for (let i = 0; i < this.reportSubjectAll.length; i++) {
            data.push({
              value: this.reportSubjectAll[i].subjectId,
              label: `${this.reportSubjectAll[i].nameTh}(${this.reportSubjectAll[i].nameEn})`,
            });
          }
          this.dataSubjectAll = data;

          this.selectedSubject = this.reportSubjectAll[0].subjectId;

          this.dataLoading1 = false;
        } else {
          this.reportSubjectAll = null;
          this.dataLoading1 = false;
        }
      } else {
        this.dataSubjectAll = null;
        this.reportSubjectAll = null;
        this.dataLoading1 = false;
      }
      this.FindReportStudentInformationStudying(this.selectedSubject);
      // console.log("--------->", this.selectedSubject);
      this.findLesson();
    });
  }

  onSelectSubject(subject: any) {
    console.log("1234", subject);
    this.selectedSubject = subject;
    this.FindReportStudentInformationStudying(this.selectedSubject);
    this.findLesson();
  }

  findLesson() {
    console.log("this.selectedSubject", this.selectedSubject);
    this.teacherService.FindLesson(this.selectedSubject).then(res => {

      if (res.status && res.dataLessons?.length) {
        this.dataFindLesson = res.dataLessons.map((item: { lesson_id: any; title: any; }) => ({
          value: item.lesson_id,
          label: item.title
        }));
        this.selectedLesson = this.dataFindLesson[0].value;
        console.log(this.dataFindLesson);
      } else {
        this.dataFindLesson = [];
      }
      this.findStudentLearnLesson();
    });
  }

  onSelectLesson(event: any) {
    console.log("LesssonSelect", event);
    this.findStudentLearnLesson();
  }

  findStudentLearnLesson() {
    this.reportLearnlesson
      .GetFindReportStudentCourses(this.selectedSubject, this.selectedLesson)
      .then(res => {
        console.log(res);
        this.reportstudyList = res.data;
        if (res.status) {
          const data = res.data;

          const listAll = data.listStudentLearn || [];

          const listToday = data.listStudentLearnToDay || [];

          this.studentLearnLesson = {
            countListAll: listAll.length,
            countListSudentLearnToDay: listToday.length
          };
        }
        console.log(this.studentLearnLesson);
        
      });
  }

  onChangSelectPortal() {
    this.adminSharedDataService.getDataelectPortal.subscribe((message) => {
      if (message != "") {
        if (this.dataLocal.role == Role.SuperAdmin || this.dataLocal.role == Role.Admin) {
          this.getTeacher();
        } else if (this.dataLocal.role == Role.Teacher) {
          this.id = this.dataLocal.id;
          this.reportSubjectAllTeacher(this.id);
        } else if (this.dataLocal.role == Role.Executive) {
          this.getTeacher();
        } else {
        }
      }
    });
  }

  FindReportStudentInformationStudying(subjectId: string) {
    var data = [];
    this.reportLearnlesson.FindReportStudentInformationStudying(subjectId).then(async (res) => {
      console.log("..>", res);

      if (res.status) {
        var dataList = res.data;
        if (dataList.dataStudying != null) {
          for (let i = 0; i < dataList.dataStudying.length; i++) {
            var id = dataList.dataStudying[i].dataExamfinal.dataSubject.subjectId;
            var idStd = dataList.dataStudying[i].dataStudent.stdntId;
            if (dataList.dataStudying[i].dataBuyCourse.statusPay == "successful") {
              data.push({
                // "progress": this.progress,
                "dataBuyCourse": dataList.dataStudying[i].dataBuyCourse,
                "dataExamfinal": dataList.dataStudying[i].dataExamfinal,
                "dataStudent": dataList.dataStudying[i].dataStudent,
              });
            }
          }
        }
      }
      var dataFilter = data.filter(f => f.progress != '100');
      this.studyingCount = dataFilter;

    })

  }

  openDataStudyingList(data: any) {
    this.myCountStudentStudying.show();
    this.studyingList = data;
    this.studyingList = this.studyingList.map((item: any, index: number) => ({ ...item, index: index + 1 }));
    this.dataStudyingOrigin = this.studyingList;
    this.dataStudyingFilterOrigin = this.studyingList;
    this.pageCount = Math.ceil(this.dataStudyingOrigin.length / this.pageTotal);
    this.studyingList = this.studyingList.slice(0, this.pageTotal);
    console.log('map', this.studyingList);

  }

  openDataStudyingCountList(data: any) {
    this.myStudentStudyingList.show();
    this.studySuccesList = data.listStudentLearn;
    this.studySuccesList = this.studySuccesList.map((item: any, index: number) => ({ ...item, index: index + 1 }));
    this.dataStudySuccesOrigin = this.studySuccesList;
    this.dataStudySuccesFilterOrigin = this.studySuccesList;
    this.pageCount1 = Math.ceil(this.dataStudySuccesOrigin.length / this.pageTotal1);
    this.studySuccesList = this.studySuccesList.slice(0, this.pageTotal1);
  }

  openDataStudyingCountList2(data: any) {
    this.myStudentStudyingList2.show();
    this.studyingToDayList = data.listStudentLearnToDay;
    this.studyingToDayList = this.studyingToDayList.map((item: any, index: number) => ({ ...item, index: index + 1 }));
    this.dataStudyToDayOrigin = this.studyingToDayList;
    this.dataStudyToDayFilterOrigin = this.studyingToDayList;
    this.pageCount2 = Math.ceil(this.dataStudyToDayOrigin.length / this.pageTotal2);
    this.studyingToDayList = this.studyingToDayList.slice(0, this.pageTotal2);
  }

  pageChange(Directive: string) {
    if (this.page >= 1 && this.page < this.pageCount && Directive == 'next' || this.page <= this.pageCount && this.page > 1 && Directive == 'prev') {
      this.studyingList = !this.searchModel ? this.dataStudyingOrigin : this.dataStudyingFilterOrigin;
      if (Directive == 'prev') this.page--;
      else this.page++;
      this.studyingList = !this.searchModel ? this.dataStudyingOrigin.slice((this.page - 1) * this.pageTotal, (this.page - 1) * this.pageTotal + this.pageTotal) : this.dataStudyingFilterOrigin.slice((this.page - 1) * this.pageTotal, (this.page - 1) * this.pageTotal + this.pageTotal);
    }
  }

  pageChange1(Directive: string) {
    if (this.page1 >= 1 && this.page1 < this.pageCount1 && Directive == 'next' || this.page1 <= this.pageCount1 && this.page1 > 1 && Directive == 'prev') {
      this.studySuccesList = !this.searchModel1 ? this.dataStudySuccesOrigin : this.dataStudySuccesFilterOrigin;
      if (Directive == 'prev') this.page1--;
      else this.page1++;
      this.studySuccesList = !this.searchModel1 ? this.dataStudySuccesOrigin.slice((this.page1 - 1) * this.pageTotal1, (this.page1 - 1) * this.pageTotal1 + this.pageTotal1) : this.dataStudySuccesFilterOrigin.slice((this.page1 - 1) * this.pageTotal1, (this.page1 - 1) * this.pageTotal1 + this.pageTotal1);
    }
  }

  pageChange2(Directive: string) {
    if (this.page2 >= 1 && this.page2 < this.pageCount1 && Directive == 'next' || this.page2 <= this.pageCount1 && this.page2 > 1 && Directive == 'prev') {
      this.studyingToDayList = !this.searchModel2 ? this.dataStudyToDayOrigin : this.dataStudyToDayFilterOrigin;
      if (Directive == 'prev') this.page2--;
      else this.page2++;
      this.studyingToDayList = !this.searchModel2 ? this.dataStudyToDayOrigin.slice((this.page2 - 1) * this.pageTotal2, (this.page2 - 1) * this.pageTotal2 + this.pageTotal2) : this.dataStudyToDayFilterOrigin.slice((this.page2 - 1) * this.pageTotal2, (this.page2 - 1) * this.pageTotal2 + this.pageTotal2);
    }
  }

  getLanguage() {
    this.adminSharedDataService.getDataLanguage.subscribe(async (message) => {
      if (message == '') {
        this.dataLanguage = localStorage.getItem('lang');
      } else {
        this.dataLanguage = message;
      }
    })
  }

}
